import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, FileText } from "lucide-react";
import { fmtEUR, fmtDate, monthsFR } from "@/lib/format";
import { toast } from "sonner";

export default function Quittances() {
  const [payments, setPayments] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [props, setProps] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/payments?status=paye"), api.get("/tenants"), api.get("/properties")]).then(([p, t, pr]) => {
      setPayments(p.data); setTenants(t.data); setProps(pr.data);
    });
  }, []);

  const tenantName = (id) => { const t = tenants.find(x => x.id === id); return t ? `${t.first_name} ${t.last_name}` : "—"; };
  const propLabel = (id) => { const p = props.find(x => x.id === id); return p ? p.address : "—"; };

  const download = async (p) => {
    try {
      const token = localStorage.getItem("gl_token");
      const resp = await fetch(`${API}/receipts/${p.id}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
      if (!resp.ok) throw new Error("Erreur génération");
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `quittance-${p.period_year}-${String(p.period_month).padStart(2,'0')}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div className="space-y-6" data-testid="quittances-page">
      <div>
        <div className="text-overline">Documents légaux</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{fontFamily:'Outfit'}}>Quittances de loyer</h1>
        <p className="text-sm text-zinc-500 mt-1">{payments.length} quittance(s) disponibles · générées automatiquement pour chaque loyer payé</p>
      </div>

      <Card className="card-flat overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 border-b border-zinc-200">
            <tr className="text-left text-xs uppercase tracking-wider text-zinc-500">
              <th className="px-4 py-3">Période</th><th className="px-4 py-3">Locataire</th>
              <th className="px-4 py-3">Bien</th><th className="px-4 py-3">Date paiement</th>
              <th className="px-4 py-3 text-right">Montant</th><th></th>
            </tr>
          </thead>
          <tbody>
            {payments.map(p => (
              <tr key={p.id} className="border-b border-zinc-100 hover:bg-zinc-50">
                <td className="px-4 py-3 font-medium">{monthsFR[p.period_month]} {p.period_year}</td>
                <td className="px-4 py-3">{tenantName(p.tenant_id)}</td>
                <td className="px-4 py-3 text-xs text-zinc-600">{propLabel(p.property_id)}</td>
                <td className="px-4 py-3 text-xs">{fmtDate(p.payment_date)}</td>
                <td className="px-4 py-3 mono text-right font-medium">{fmtEUR(p.amount_paid)}</td>
                <td className="px-4 py-3 text-right">
                  <Button size="sm" variant="outline" onClick={() => download(p)} data-testid={`dl-receipt-${p.id}`}><Download className="w-3.5 h-3.5 mr-1" />PDF</Button>
                </td>
              </tr>
            ))}
            {payments.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-zinc-500"><FileText className="w-8 h-8 mx-auto mb-2 opacity-40" />Pas encore de quittance. Enregistrez un paiement complet pour générer une quittance.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
